export { default as TMTapeLab } from './TMTapeLab/TMTapeLab'
